import axios from "axios";
import { makeQueryString } from "@/utils/Query.js";

const API_BASE_URL = process.env.VUE_APP_API_URL;

const config = {
    baseUrl: `${API_BASE_URL}/homepage/brand/`
};

const normalizeConditions = (conditions = {}) => {
    return Object.entries(conditions).reduce((params, [key, value]) => {
        if (value === "" || value === null || value === undefined || value === false) {
            return params;
        }

        params[key] = value;
        return params;
    }, {});
};

const brandAPIDFN = {
    brandAPI: (APIName, conditions, paths) => {
        return brandAPI[APIName](conditions, paths);
    }
};

const brandAPI = {
    API_BASE_URL,
    selectGs25Stores: (conditions, paths) => {
        const uri = paths || "storeSearch/selectGs25Stores";
        return axios.get(`${config.baseUrl}${uri}${makeQueryString(normalizeConditions(conditions))}`);
    },
    selectGtfStores: (conditions, paths) => {
        const uri = paths || "storeSearch/selectGtfStores";
        return axios.get(`${config.baseUrl}${uri}${makeQueryString(normalizeConditions(conditions))}`);
    },
    selectMembershipFaq: (conditions, paths) => {
        const uri = paths || "membership/selectMembershipFaq"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectBestMembershipFaq: (conditions, paths) => {
        const uri = paths || "membership/selectBestMembershipFaq"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getMembershipFaq: (conditions, paths) => {
        const uri = paths || "membership/getMembershipFaq"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
};

export { brandAPIDFN, brandAPI };
